/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { I18n } from '@coze-arch/i18n';
import { type BotSpace, SpaceType } from '@coze-arch/bot-api/developer_api';

/** 个人空间等默认英文 name 映射为当前语言展示名 */
export const getSpaceDisplayName = (
  space: Pick<BotSpace, 'name' | 'space_type'>,
): string =>
  space.space_type === SpaceType.Personal
    ? I18n.t('menu_title_personal_space')
    : space.name;
